<template>
<div>
        <div
        v-if="isShowDialog"
        id="toca_folder_operation_dialog"
        class="toca_folder_operation_dialog"
        ></div>
    </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import "@toca/toca-folder-operation-dialog/dist/style.css";
import { TocaFolderOperationDialog } from "@toca/toca-folder-operation-dialog";
import { createCopyCloudDocumentFile, kbCreateCopy, kbCreateFile, createFile, fileMove, createCopyCloudDocumentFolder, createCopyCloudFolder } from "@/api/h5/file";
import { mapState } from "vuex";
import { waitFileCopyTaskComplete } from "@/pages/H5/Cloud/utils/fileCopyTask";

export default {
  name: 'FolderOperationDialog',
  props: {
    sourceFileData: {
      type: Object,
      required: true
    },
    userInfo: {
      type: Object,
      required: true
    }
  },
  emits: [],
  components: {},
  data() {
    return {
      isShowDialog: false,
      folderOperationDialog: null,
      copyCreating: false
    };
  },
  computed: {
    ...mapState({
      cloudI18n: (state) => state.cloudI18n
    }),
    locale() {
      return this.cloudI18n || localStorage.getItem("tci18nLocale") || navigatorLang[navigator.language] || "zh-cn";
    },
    sourceType() {
      if (this.sourceFileData?.productType === 'CLOUD_FILE') {
        return 'CLOUD_DISK';
      } else if (this.sourceFileData?.productType === 'WIKI_FILE') {
        return 'WIKI';
      } else if (
      this.sourceFileData?.productType === 'CLOUD_DOCUMENT' ||
      this.sourceFileData?.productType === 'NEW_MEETING_MINUTES')
      {
        return 'CLOUD_DOCUMENT';
      }
    },
    sourceWikiSpaceId() {
      if (this.sourceFileData?.productType === 'WIKI_FILE') {
        return this.sourceFileData?.relTargetId ?? '';
      }
      return '';
    },
    env() {return process.env.VUE_APP_STATIC_NODE_ENV;}
  },
  methods: {
    getTargetTypes(operationType) {
      let targetTypes = [];
      if (this.sourceType === 'CLOUD_DISK') {
        switch (this.sourceFileData?.source) {
          case 'MINE':
            targetTypes = ['MY_DISK', 'ENTERPRISE'];
            break;
          case 'BIZ':
            if (operationType === 'CREATE_COPY' || operationType === 'CREATE_WITH_TEMPLATE') {
              targetTypes = ['MY_DISK', 'ENTERPRISE'];
            } else if (operationType === 'MOVE') {
              targetTypes = ['ENTERPRISE'];
            }
            break;
          case 'SHARE_ME':
            if (operationType === 'CREATE_COPY' || operationType === 'CREATE_WITH_TEMPLATE') {
              targetTypes = ['MY_DISK', 'ENTERPRISE'];
            }
            break;
        }
      } else if (this.sourceType === 'CLOUD_DOCUMENT') {
        const wikiSupportTypes = ["DOCUMENT", "EXCEL", "PPT", "FLOW_CHART", "MIND", "SMART_SHEET", "BOARD"];
        const docType = this.sourceFileData.contentType.toUpperCase();
        const isWikiType = docType && docType.length > 0 && wikiSupportTypes.includes(docType);
        switch (this.sourceFileData?.source) {
          case 'MINE':
            if (isWikiType) {
              targetTypes = ['MY_DOC', 'SHARE_TO_ME', 'WIKI'];
            } else {
              targetTypes = ['MY_DOC', 'SHARE_TO_ME'];
            }
            break;
          case 'SHARE_ME':
            // 只能创建副本or使用模版创建
            if (operationType === 'CREATE_COPY' || operationType === 'CREATE_WITH_TEMPLATE') {
              if (isWikiType) {
                targetTypes = ['MY_DOC', 'SHARE_TO_ME', 'WIKI'];
              } else {
                targetTypes = ['MY_DOC', 'SHARE_TO_ME'];
              }
            }
            break;
        }
      } else if (this.sourceType === 'WIKI') {
        if (operationType === 'MOVE') {
          targetTypes = ['WIKI'];
        } else {
          targetTypes = ['MY_DOC', 'SHARE_TO_ME', 'WIKI'];
        }
      }
      return targetTypes;
    },
    showCopyDialog() {
      this.isShowDialog = true;
      let that = this;
      setTimeout(() => {
        const params = {
          sourceType: this.sourceType,
          operationType: 'CREATE_COPY',
          targetTypes: this.getTargetTypes('CREATE_COPY'),
          sourceFileData: this.sourceFileData,
          userInfo: this.userInfo,
          sourceWikiSpaceId: this.sourceWikiSpaceId,
          locale: this.locale,
          env: this.env,
          onCancel: () => {
            that.isShowDialog = false;
          },
          onSelectFile: (data) => {
            that.gotoCreateCopy(data);
          }
        };

        this.folderOperationDialog = new TocaFolderOperationDialog(
          '#toca_folder_operation_dialog',
          params
        );
      }, 0);
    },
    showMoveDialog() {
      this.isShowDialog = true;
      let that = this;
      setTimeout(() => {
        const params = {
          sourceType: this.sourceType,
          operationType: 'MOVE',
          targetTypes: this.getTargetTypes('MOVE'),
          sourceFileData: this.sourceFileData,
          userInfo: this.userInfo,
          sourceWikiSpaceId: this.sourceWikiSpaceId,
          locale: this.locale,
          env: this.env,
          onCancel: () => {
            that.isShowDialog = false;
          },
          onSelectFile: (data) => {
            that.confirmMove(data);
          }
        };
        this.folderOperationDialog = new TocaFolderOperationDialog(
          '#toca_folder_operation_dialog',
          params
        );
      }, 0);
    },
    showCreateFileWithTemplateDialog(templateId) {
      this.isShowDialog = true;
      let that = this;
      setTimeout(() => {
        const params = {
          sourceType: this.sourceType,
          operationType: 'CREATE_WITH_TEMPLATE',
          targetTypes: this.getTargetTypes('CREATE_WITH_TEMPLATE'),
          sourceFileData: this.sourceFileData,
          userInfo: this.userInfo,
          sourceWikiSpaceId: this.sourceWikiSpaceId,
          locale: this.locale,
          env: this.env,
          onCancel: () => {
            that.isShowDialog = false;
          },
          onSelectFile: (data) => {
            that.createFileWithTemplate(data);
          }
        };

        this.folderOperationDialog = new TocaFolderOperationDialog(
          '#toca_folder_operation_dialog',
          params
        );
      }, 0);
    },
    resolveCopyResponseBody(res) {
      return res?.data?.code ? res.data : res;
    },
    buildCopyFileOpenUrl(fileInfo, selectedProductType) {
      if (!fileInfo) return "";
      if (fileInfo.fileUrl) return fileInfo.fileUrl;
      if (!fileInfo.fileId) return "";
      if (selectedProductType === "WIKI_FILE") {
        return `https:${process.env.VUE_APP_WIKI_URL}/wiki?fid=${fileInfo.fileId}`;
      }
      const { origin, pathname } = window.location;
      if (pathname === "/web/file") {
        return `${origin}${pathname}#/?fid=${fileInfo.fileId}`;
      }
      return `${origin}${pathname}?fid=${fileInfo.fileId}`;
    },
    handleCreateCopySuccess(fileInfo, selectedProductType) {
      this.$message.success(intl.$t("创建副本成功#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_1"));
      this.isShowDialog = false;
      const openUrl = this.buildCopyFileOpenUrl(fileInfo, selectedProductType);
      if (openUrl) {
        setTimeout(() => {
          window.open(openUrl, '_blank');
        }, 500);
      }
    },
    async handleCreateCopyResponse(res, selectedProductType) {
      const responseBody = this.resolveCopyResponseBody(res);
      const { code, data: copyResult, message } = responseBody || {};
      if (code !== 200) {
        throw new Error(message || intl.$t("创建副本失败#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_1"));
      }
      const fileInfo = await waitFileCopyTaskComplete(copyResult);
      this.handleCreateCopySuccess(fileInfo, selectedProductType);
    },
    async gotoCreateCopy(data) {
      if (this.copyCreating) return;
      this.copyCreating = true;
      const selectedProductType = data.selectedProductType;
      const sourceFileData = data.sourceFileData;
      const selectedNode = data.selectedNode;
      const createNameText = data.createNameText;
      const fileName = sourceFileData.fileName || '';
      let suffix = fileName.includes(".") ? fileName.slice(fileName.lastIndexOf(".") + 1) : "";
      if (sourceFileData.contentType === 'DOCUMENT') {
        suffix = '';
      } else {
        suffix = suffix.length > 0 ? '.' + suffix : '';
      }
      try {
        if (selectedProductType === 'WIKI_FILE') {
          const res = await kbCreateCopy(sourceFileData.fileId, selectedNode.fileId, createNameText + suffix);
          await this.handleCreateCopyResponse(res, selectedProductType);
        } else if (selectedProductType === 'CLOUD_DOCUMENT' || selectedProductType === 'CLOUD_FILE') {
          const res = await createCopyCloudDocumentFile(sourceFileData.fileId, selectedNode.fileId, createNameText + suffix);
          await this.handleCreateCopyResponse(res, selectedProductType);
        }
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : intl.$t("创建副本失败#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_2");
        this.$message.error(errorMessage || intl.$t("创建副本失败#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_3"));
        console.error(error);
      } finally {
        this.copyCreating = false;
      }
    },
    async createFileWithTemplate(data) {
      const createNameText = data.createNameText;
      const selectedProductType = data.selectedProductType;
      const sourceFileData = data.sourceFileData;
      const selectedNode = data.selectedNode;
      const fileName = sourceFileData.fileName || '';
      let suffix = fileName.includes(".") ? fileName.slice(fileName.lastIndexOf(".") + 1) : "";
      if (sourceFileData.contentType === 'DOCUMENT') {
        suffix = '';
      } else {
        suffix = suffix.length > 0 ? '.' + suffix : '';
      }
      if (selectedProductType === 'WIKI_FILE') {
        const res = await kbCreateFile('WIKI_FILE', sourceFileData.contentType, selectedNode.fileId, sourceFileData.fileId, createNameText + suffix);
        const { code, data } = res;
        if (code === 200) {
          this.$message.success(intl.$t("创建文件成功#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_1"));
          this.isShowFolderOperationDialog = false;
          setTimeout(() => {
            window.open(data.fileUrl, '_blank');
          }, 500);
        } else {
          this.$message.error(intl.$t("创建文件失败#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_1"));
          console.error(message);
        }
      } else if (selectedProductType === 'CLOUD_DOCUMENT') {
        createFile({
          templateFileId: sourceFileData.fileId,
          newFileType: sourceFileData.contentType,
          parentId: selectedNode.fileId,
          fileName: createNameText + suffix,
          productType: 'CLOUD_DOCUMENT'
        }).then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.$message.success(intl.$t("创建文件成功#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_2"));
            setTimeout(() => {
              window.open(data.fileUrl, '_blank');
            }, 500);
          } else {
            this.$message.error(intl.$t("创建文件失败#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_2"));
          }
        }).catch((err) => {
          this.$message.error(intl.$t("创建文件失败#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_3"));
        });
      } else if (selectedProductType === 'CLOUD_FILE') {
        kbCreateFile('CLOUD_FILE', sourceFileData.contentType, selectedNode.fileId, sourceFileData.fileId, createNameText + suffix).then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.$message.success(intl.$t("创建文件成功#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_3"));
            setTimeout(() => {
              window.open(data.fileUrl, '_blank');
            }, 500);
          } else {
            this.$message.error(intl.$t("创建文件失败#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_4"));
          }
        }).catch((err) => {
          this.$message.error(intl.$t("创建文件失败#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_5"));
        });
      }
    },
    async confirmMove(data) {
      const sourceFileData = data.sourceFileData;
      const selectedNode = data.selectedNode;
      const selectedProductType = data.selectedProductType;
      try {
        const res = await fileMove(sourceFileData.fileId, selectedNode.fileId, '1');
        const { code, message } = res;
        if (code === 200) {
          this.$message.success(intl.$t("移动成功，页面已继承新父页面的权限#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_1"));
          this.isShowFolderOperationDialog = false;
          setTimeout(() => {
            if (selectedProductType === 'WIKI_FILE') {
              window.open(`https:${process.env.VUE_APP_WIKI_URL}/wiki?fid=${sourceFileData.fileId}`, '_self');
            } else {
              window.location.reload();
            }
          }, 500);
        } else {
          this.$message.error(intl.$t("移动失败#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_1"));
          console.error(message);
        }
      } catch (error) {
        this.$message.error(intl.$t("移动失败#!!!#src/pages/H5/Cloud/components/dialog/FolderOperationDialog.vue_2"));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.toca_folder_operation_dialog {
  z-index: 1001;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #12131728;
}
</style>

<style lang="scss">
.tree-node-title-text {
  max-width: 100% !important;
  height: 24px !important;
  line-height: 20px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid #5c70ff;
  border-radius: 2px;
  padding: none !important;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
}

.tree-node-input-text {
  max-width: 100% !important;
  height: 24px !important;
  line-height: 20px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid #5c70ff;
  border-radius: 2px;
  padding: none !important;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  outline-width: 0px;
}

.tree-node-input-text:focus {
  max-width: 100% !important;
  height: 24px !important;
  line-height: 20px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid #5c70ff;
  border-radius: 2px;
  padding: none !important;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  outline-width: 0px;
}

.tree-node-input-text::selection {
  background-color: #5c70ff;
  color: white;
}

.arco-tree {
  flex: 1 !important;
  min-height: 0px;
  padding: 5px 8px 0px 8px !important;

  // .arco-modal-draggable .arco-modal-header {
  //   cursor: pointer;
  // }

  .arco-tree-node {
    cursor: pointer;
    padding-left: 0px;
    margin: 1px 0px;
  }

  .arco-tree-node-expand:hover {
    background-color: #eaebec;
    border-radius: 8px;

    .kb_dir_node_more {
      display: flex;
    }
  }

  .arco-tree-node-title-highlight {
    background-color: #e7eaff;
  }

  .arco-tree-node-title-dragging:hover {
    color: #5c70ff;
    opacity: 0.6;
    background-color: #5c70ff;
  }

  .arco-tree-node-title-gap-top::before {
    top: -2px;
    background-color: #5c70ff !important;
    // background-color: transparent;
    z-index: 1000;
  }

  .arco-tree-node-switcher-topArrow {
    top: -6px !important;
  }

  .arco-tree-node-switcher-bottomArrow {
    bottom: -6px !important;
  }

  .arco-tree-node-title-gap-bottom::before {
    top: unset;
    bottom: -2px;
    z-index: 1000;
    background-color: #5c70ff !important;
  }

  .arco-tree-node-selected {
    background-color: #e7eaff !important;
    border-radius: 8px;
    .arco-tree-node-title-text {
      color: #5c70ff;
    }
  }
}

.arco-tree-node-is-leaf {
}

.arco-tree-node-switcher {
  //图标 12 x 12
  margin-left: 4px !important;
  margin-right: 4px !important;

  .arco-tree-node-switcher-icon:hover {
    border-radius: 4px;
    background-color: #22232915 !important;
  }
}

.arco-tree-node-title-expand:hover {
  // background-color: transparent;
  background-color: #eaebec;
}

.arco-tree-node-title:hover {
  background-color: transparent !important;
}

.arco-tree-node-title {
  height: 34px;
  min-width: 0;
  flex: 1;
  margin-left: 0px !important;
  padding: 0px !important;
  padding-left: 4px !important;

  .arco-tree-node-icon {
    margin-right: 4px !important;
    margin-left: -4px !important;
    width: 16px !important;
    height: 16px !important;

    .kb-dir-icon {
      width: 16px !important;
      height: 16px !important;
    }
  }

  .arco-tree-node-title-text {
    //文本
    min-width: 0;
    flex: 1;
    height: 34px !important;
    line-height: 34px !important;
    display: block !important;
    overflow: hidden !important;
    white-space: nowrap;
    text-overflow: ellipsis !important;
  }

  .arco-tree-node-title-text-nowrap {
    white-space: nowrap !important;
  }
}
// 输入框样式
</style>
